import { createSlice } from "@reduxjs/toolkit";

const utilsSlice = createSlice({
  name: "utils",
  initialState: {
    loading: false,
    visible: false,
    message: '',
    type: null, // "error" | "success" | null (null = guess from the text)
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    showToast: (state, action) => {

      state.visible = true;
      // Accepts "text" or { message, type: "error" | "success" }.
      const payload = action.payload;
      state.message = typeof payload === "object" && payload !== null ? payload.message : payload;
      state.type = typeof payload === "object" && payload !== null ? payload.type || null : null;
    },
    hideToast: (state) => {
      state.visible = false;
      state.message = ''; // Clear the message when hiding Snackbar
      state.type = null;
    },
  },
});

export const { setLoading, showToast, hideToast } = utilsSlice.actions;
export default utilsSlice.reducer;